import { t } from '@lingui/core/macro';
import { Box, TeamAvatar, UserAvatar } from '@pocketlaw/tetris';
import { Container } from './styled';
export function Approver(props) {
    const { name, subtitle, endElement, type = 'user' } = props;
    const deletedUser = t({
        message: 'Deleted user',
        comment: 'Fallback name when user does not exist',
    });
    const deletedTeam = t({
        message: 'Unknown team',
        comment: 'Fallback name when team does not exist',
    });
    return (<Container>
      <Box alignItems="center" justifyContent="space-between" width="100%">
        {type === 'user' ? (<UserAvatar size="sm" title={name || deletedUser} subtitle={subtitle}/>) : (<TeamAvatar size="sm" title={name || deletedTeam}/>)}
        {endElement}
      </Box>
    </Container>);
}
